<template>
  <v-btn color="primary" style="padding: 0 10px 0 12px;" small class="filter-selector elevation-0" v-if="filter.isActive" @click="unselect">
    <div class="filter-selector__label">
      <template v-if="filter.label">
        {{ filter.label }}
      </template>

      <template v-else>
        <lang :t="'FILTER-' + filter.name.toUpperCase()" />
      </template>
    </div>
    <div class="filter-selector__action">
      <template v-if="selectedLabels">
        <span v-for="(selectedValue, index) in selectedLabels" :key="index">
          {{ selectedValue }}<template v-if="(index+1 < selectedLabels.length)">,</template>
        </span>
      </template>
      <span class="filter-selector__delete-icon"> <v-icon x-small>mdi-close</v-icon></span>
    </div>
  </v-btn>
</template>

<script>
export default {
  name: "FilterSelector",
  props: {
    filter: {
      type: Object,
      required: true,
    },
  },
  watch: {
    changed: {
      handler() {
        this.filter.isActive = this.selected();
      },
      immediate: true,
      deep: true,
    },
    filter: {
      handler() {
        this.filter.isActive = this.selected();
      },
      deep: true,
    },
  },
  created() {
    this.initSelectionState = this.filter && this.filter.selection;
  },
  computed: {
    selectedValues() {
      if (!this.filter || (this.filter && !this.filter.selection)) return "";
      if (typeof this.filter.selection === "string") return this.filter.selection;
      if (typeof this.filter.selection === "number") return this.filter.selection;
      if (Array.isArray(this.filter.selection)) return this.filter.selection.join(",");
      if (this.filter.type === "slipsheet") {
        return this.filter.selection.join(", ");
      }
      return Object.values(this.filter.selection)
        .filter((el) => el != null)
        .join(",");
    },
    selectedLabels() {
      if (!this.filter || (this.filter && (this.filter.selection === null || this.filter.selection === undefined))) return [""];
      if (typeof this.filter.selection === "string") {
        if (!this.filter.options) return [this.filter.selection];
        const foundItem = this.filter.options.find((el) => {
          if(this.filter.itemValue){
            return el[this.filter.itemValue] === this.filter.selection;
          }else{
            return el.id == this.filter.selection
          }
        });
        if(this.filter.itemText && foundItem[this.filter.itemText]) return [foundItem[this.filter.itemText]];
        return [foundItem.displayName || "unknown"];
      }else if (typeof this.filter.selection === "number") {
        const foundItem = this.filter.options.find((el) => {
          if(this.filter.itemValue){
            return el[this.filter.itemValue] === this.filter.selection;
          }else{
            return el.id == this.filter.selection
          }
        });
        if(this.filter.itemText && foundItem[this.filter.itemText]) return [foundItem[this.filter.itemText]];
        if (foundItem && foundItem.displayName) return [foundItem.displayName];
        if (foundItem && foundItem.name) return [foundItem.name];
        return ["unknown"];
      }else if (this.filter.type === "slipsheet") {
        if (!this.filter.selection) return [];
        const options1Picked = this.filter.options1.filter((el) => this.filter.selection.includes(el.value));
        let slipsheetLabels = [];
        if (options1Picked) {
          slipsheetLabels = [...options1Picked.map((el) => el.label)];
        }
        const option2Picked = this.filter.options2.find((el) => this.filter.selection.includes(el.value));
        if (option2Picked) {
          slipsheetLabels.push(option2Picked.label);
        }
        return slipsheetLabels;
      }else if(this.filter.type === 'dateRange'){
        return this.filter.selection;
      }else if (Array.isArray(this.filter.selection)) {
        const foundItems = this.filter.options.filter((el) => {
          let id = 0;
          if (el.id !== undefined) id = el.id;
          if (el.value !== undefined) id = el.value;
          return this.filter.selection.includes(id);
        });
        return foundItems.map(el => {
          if(el.name !== undefined) return el.name;
          return el.label;
        }) || ["unknown"];
      }else{
        const selectedItems = [];
        for (const [key, value] of Object.entries(this.filter.selection)) {
          if (value !== null && value !== "") selectedItems.push(`${key}: ${value}`);
        }

        return selectedItems;
      }
      
    },
  },
  data() {
    return {
      changed: false,
      isSelected: false,
    };
  },
  methods: {
    selected() {
      if (!this.filter || (this.filter && !this.filter.selection)) return false;
      if (typeof this.filter.selection === "string") return this.filter.selection || false;
      if (typeof this.filter.selection === "number") return this.filter.selection || false;
      if (Array.isArray(this.filter.selection)) return this.filter.selection.length > 0 || false;

      return Object.values(this.filter.selection).filter((el) => el != null && el !== "").length > 0;
    },
    unselect() {
      this.filter.isActive = false;

      this.changed = !this.changed;
      if (typeof this.filter.selection === "string" || typeof this.filter.selection === "number") {
        if (this.filter.type === "default" || this.filter.type === 'search') {
          const options = this.filter.options.map((option) => {
            return Object.assign(option, { isSelected: false });
          });
          this.filter = Object.assign(this.filter, { options, selection: undefined });
        } else {
          this.filter.selection = undefined;
        }
      }else if (Array.isArray(this.filter.selection)) {
        this.filter.selection = [];
      } else {
        this.filter.selection = Object.assign(
          {},
          ...Object.keys(this.filter.selection).map((key) => {
            return { [key]: null };
          })
        );
      }
      this.$emit('unselected');
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-selector {
  margin-right: 0.2em;
  margin-bottom: 0.4em;

  &__label,
  &__action {
    font-family: Arial, sans-serif;
    font-weight: 700;
    font-size: 10px;
    line-height: 11.5px;
    letter-spacing: 0.8px;
  }

  &__label {
    color: lighten(#1b99a7, 45);
  }

  &__action {
    margin-left: 1em;
    display: flex;
    align-items: center;
    & > span {
      display: inline-block;
      text-transform: lowercase;
      &::first-letter {
        text-transform: uppercase;
      }
    }
  }
    &__delete-icon{
      padding-left: 4px;
      color: lighten(#1b99a7, 25);
    }
}
</style>
